import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

export default function Stats() {
  const [overview, setOverview]     = useState(null);
  const [byHotel, setByHotel]       = useState([]);
  const [byDept, setByDept]         = useState([]);
  const [trend, setTrend]           = useState([]);
  const [dateFrom, setDateFrom]     = useState('');
  const [dateTo, setDateTo]         = useState('');
  const [loading, setLoading]       = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    let qs = '';
    if (dateFrom) qs += `date_from=${dateFrom}&`;
    if (dateTo)   qs += `date_to=${dateTo}`;
    const [ov, bh, bd, tr] = await Promise.all([
      fetch(`${API}/stats/overview?${qs}`).then(r => r.json()),
      fetch(`${API}/stats/by-hotel?${qs}`).then(r => r.json()),
      fetch(`${API}/stats/by-department?${qs}`).then(r => r.json()),
      fetch(`${API}/stats/trend`).then(r => r.json()),
    ]);
    setOverview(ov); setByHotel(bh); setByDept(bd); setTrend(tr);
    setLoading(false);
  }

  const fmt = v => v ? parseFloat(v).toLocaleString('ru') + ' ₽' : '0 ₽';

  const maxPayable = byHotel.length ? Math.max(...byHotel.map(h => parseFloat(h.total_payable || 0))) : 1;

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Статистика ФОТ</h2>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }} />
          <span style={{ color:'#6b7280' }}>—</span>
          <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }} />
          <button className="btn-primary" onClick={load} disabled={loading}>{loading ? '...' : 'Применить'}</button>
        </div>
      </div>

      {overview && (
        <div className="stat-cards">
          <div className="stat-card">
            <div className="label">Всего начислено</div>
            <div className="value" style={{ fontSize:22 }}>{fmt(overview.total_accrued)}</div>
          </div>
          <div className="stat-card">
            <div className="label">К выплате</div>
            <div className="value green" style={{ fontSize:22 }}>{fmt(overview.total_payable)}</div>
          </div>
          <div className="stat-card">
            <div className="label">Штрафы</div>
            <div className="value red" style={{ fontSize:22 }}>−{fmt(overview.total_fines)}</div>
          </div>
          <div className="stat-card">
            <div className="label">Плюсы</div>
            <div className="value green" style={{ fontSize:22 }}>+{fmt(overview.total_bonuses)}</div>
          </div>
          <div className="stat-card">
            <div className="label">Сотрудников</div>
            <div className="value" style={{ fontSize:22 }}>{overview.employee_count}</div>
          </div>
          <div className="stat-card">
            <div className="label">Объектов</div>
            <div className="value" style={{ fontSize:22 }}>{overview.hotel_count}</div>
          </div>
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginBottom:24 }}>
        {/* По отделам */}
        <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>По отделам</h3>
          {byDept.length === 0 && <div style={{ color:'#9ca3af', fontSize:14 }}>Нет данных</div>}
          {byDept.map((d, i) => (
            <div key={i} style={{ marginBottom:12 }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                <span style={{ fontSize:14, fontWeight:500 }}>{d.department_name}</span>
                <span style={{ fontSize:14, fontWeight:600 }}>{fmt(d.total_payable)}</span>
              </div>
              <div style={{ fontSize:12, color:'#6b7280' }}>
                Сотрудников: {d.employee_count} · Штрафы: {fmt(d.total_fines)} · Плюсы: {fmt(d.total_bonuses)}
              </div>
            </div>
          ))}
        </div>

        {/* Тренд по месяцам */}
        <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>Динамика ФОТ по месяцам</h3>
          {trend.length === 0 && <div style={{ color:'#9ca3af', fontSize:14 }}>Нет данных</div>}
          {trend.map((t, i) => (
            <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #f3f4f6' }}>
              <span style={{ fontSize:13, color:'#6b7280' }}>{t.month}</span>
              <span style={{ fontSize:13, fontWeight:600 }}>{fmt(t.total_payable)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* По отелям */}
      <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
        <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>ФОТ по объектам</h3>
        {byHotel.length === 0 && <div style={{ color:'#9ca3af', fontSize:14 }}>Нет данных</div>}
        {byHotel.map((h, i) => (
          <div key={i} style={{ marginBottom:14 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
              <span style={{ fontSize:14, fontWeight:500 }}>{h.hotel_name}</span>
              <span style={{ fontSize:14, fontWeight:700 }}>{fmt(h.total_payable)}</span>
            </div>
            <div style={{ height:8, background:'#f3f4f6', borderRadius:4, overflow:'hidden' }}>
              <div style={{
                height:'100%', borderRadius:4, background:'#111827',
                width: `${(parseFloat(h.total_payable || 0) / maxPayable * 100).toFixed(1)}%`,
                transition:'width 0.3s',
              }} />
            </div>
            <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>
              {h.employee_count} сотр. · Штрафы: {fmt(h.total_fines)} · Плюсы: {fmt(h.total_bonuses)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
